/* Copyright (c) 2021, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { PlatformDetectorService } from '../platform-detector/platform-detector.service';

const TransparentBackground = 'transparent';
const OpaqueBackground = '#191919';

/**
 * @name backgroundColorService
 * @description
 * Optional service meant to manage the background color, which should be transparent
 * for desktop when streaming (can be opaque otherwise), and opaque for browsers
 */
@Injectable({
    providedIn: 'root'
})
export class BackgroundColorService {
    private enabled = false;
    private isBrowser = false;

    constructor() {
        this.isBrowser = PlatformDetectorService.isBrowserPlatform();
    }

    init(enable: boolean) {
        this.enabled = enable;
        if (this.enabled) {
            this.setDefaultStyle();
        }
    }

    private setStyle(style: string) {
        document.documentElement.style.background = style;
        document.body.style.background = style;
    }

    setDefaultStyle() {
        this.setStyle(this.isBrowser ? OpaqueBackground : TransparentBackground);
    }

    // For desktop clients, set to transparent background or not.  Non-desktop is always opaque
    setTransparent(transparent: boolean) {
        if (transparent && !this.isBrowser) {
            this.setStyle(TransparentBackground);
        } else {
            this.setDefaultStyle();
        }
    }
}
